import PaginationRequest from '../entities/pagination-request'

export default (call: () => Promise<void>) => {
  return async (val: PaginationRequest, old: PaginationRequest) => {
    if (val.page !== old.page
      || val.sortBy !== old.sortBy
      || val.sortDesc !== old.sortDesc) {
      await call()
    }
  }
}
